import React  from 'react'
import { Link } from "react-router-dom";


const Vendorwithdraw = () => {

//     const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//     const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = alltest.slice(indexOfFirstItem, indexOfLastItem);

//   const pageNumbers = [];
//   for (let i = 1; i <= Math.ceil(alltest.length / itemsPerPage); i++) {
//     pageNumbers.push(i);
//   }

  return (
    <section>
      <div className="container-fluid mt-4">
        <div className="row">
          <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                <i className="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>Vendor Deposit</h6>
          </div>
          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>List Of Vendor Deposit</h4>
              </div>
              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3"></div>
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div className="table-responsive">
                    <table className="table table-bordered  mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th>Sl No</th>
                          <th>Vendor Id</th>
                          <th>Vendor Name</th>
                          <th>Withdraw Amount</th>
                          <th>Send Amount</th>
                          <th>Account No.</th>
                          <th>IFSC</th>
                          <th>Bank</th>
                          <th>Branch</th>
                          <th>Account Photo</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {currentItems.map((category, index) => {
                          const slNo = index + 1 + (currentPage - 1) * itemsPerPage;
                          return ( */}
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>

                              <td>
                                
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>
                                <button
                                  className="btn btn-success"
                                //   onClick={() => deleteCategory(category.id, category.testimonialname)}
                                >
                                  Approval
                                </button>
                                <button className='btn btn-danger mx-2'>Reject</button>

                              </td>
                            </tr>
                          {/* );
                        })} */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Pagination controls here */}
      {/* <ul className="pagination">
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${currentPage === number ? 'active' : ''}`}
          >
            <button
              onClick={() => setCurrentPage(number)}
              className="page-link"
            >
              {number}
            </button>
          </li>
        ))}
        <div className="col-lg-3">
          {currentPage > 1 && (
            <button
              className="btn btn-primary"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Previous
            </button>
          )}
        </div>
        <div className="col-lg-3">
          {currentPage < pageNumbers.length && (
            <button
              className="btn btn-primary"
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </button>
          )}
        </div>
      </ul> */}

    </section>
  )
}

export default Vendorwithdraw;